import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-access-denied',
  templateUrl: './access-restricted.component.html',
  styleUrls: ['./access-restricted.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccessRestrictedComponent {
}
